import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string, search: string): SafeHtml {
    if (!search || !text) return text;
  
    const trimmedSearch = search.trim();
    if (!trimmedSearch) return text;
  
    const escapedSearch = trimmedSearch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  
    // Match ALL consecutive runs of the search string
    const regex = new RegExp(`(?:${escapedSearch})+`, 'gi');
  
    const highlighted = text.replace(regex, match => `<span class="highlighted">${match}</span>`);
  
    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }
  
}
